export default "__VITE_ASSET__CC9EiGIT__"